(() => {
  function enhance(section) {
    if (section.dataset.cmProductEnhanced === 'true') return;
    section.dataset.cmProductEnhanced = 'true';
    if (section.dataset.cmProductMode === 'workshop') return;
    const total = section.querySelector('[data-cm-product-total]');
    const variantSelect = section.querySelector('[data-product-select]');
    const quantity = section.querySelector('input[name="quantity"]');
    const json = section.querySelector('[data-variant-json]');
    if (!total || !variantSelect || !quantity || !json) return;
    let variants;
    try { variants = JSON.parse(json.textContent); } catch { return; }
    const currency = section.dataset.cmCurrency || 'AUD';
    const formatter = new Intl.NumberFormat('en-AU', { style: 'currency', currency, currencyDisplay: 'narrowSymbol' });
    function update(variant) {
      const selected = variant || variants.find(item => String(item.id) === variantSelect.value);
      const count = Number.parseInt(quantity.value, 10);
      if (!selected || !Number.isFinite(count) || count < 1) return;
      total.textContent = formatter.format(selected.price * count / 100);
      const subtitle = section.querySelector('[data-cm-variant-subtitle]');
      if (subtitle) subtitle.textContent = selected.title;
    }
    section.addEventListener('variantChange', event => update(event.detail.variant));
    quantity.addEventListener('input', () => update());
    quantity.addEventListener('change', () => update());
    section.addEventListener('click', event => {
      if (event.target.closest('.js-qty__adjust')) window.setTimeout(() => update(), 0);
    });
    update();
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-cm-product-main]').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('cm:select-product-option', event => {
    const detail = event.detail || {};
    const section = Array.from(document.querySelectorAll('[data-cm-product-main]')).find(item => item.dataset.productId === String(detail.productId));
    if (!section || section.dataset.cmProductMode === 'workshop') return;
    const selector = Array.from(section.querySelectorAll('select[data-variant-input]')).find(item => item.dataset.index === `option${Number(detail.optionIndex)}`);
    if (!selector || !Array.from(selector.options).some(option => option.value === detail.value && !option.disabled)) return;
    selector.value = detail.value;
    selector.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
